module.exports = __webpack_public_path__ + "static/media/Levin_Armless.26f33080.jpg";